import { render, staticRenderFns } from "./photos.vue?vue&type=template&id=aa2dec92&scoped=true&"
import script from "./photos.vue?vue&type=script&lang=ts&"
export * from "./photos.vue?vue&type=script&lang=ts&"
import style0 from "./photos.vue?vue&type=style&index=0&id=aa2dec92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2dec92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
